import React, { Component } from 'react';
import axios from 'axios';

import Banner from './../molecules/InputBlog/Banner.jsx'
import Disqus from './../molecules/InputBlog/Disqus.jsx'
import ErrorBlog from './errors 404/ErorrBlog.jsx';
import MainBlog from '../molecules/InputBlog/MainBlog.jsx';

class PageInputBlog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataInputBlog: []
        }
    }

    // PETITION IS API REST
    componentDidMount() {
        axios.get("https://raw.githubusercontent.com/eliud-cesar/apis-portfolio/master/blog.json")
            .then(resp => {
                this.setState({
                    dataInputBlog: resp.data
                })
            })
            
    }

    render() {
        const { dataInputBlog } = this.state
        const UrlBlog = dataInputBlog.filter(c => c.url === this.props.match.params.url)[0]

        return(
            UrlBlog ? 
            <>
                {/* BANNER */}
                < Banner
                    Title={UrlBlog.Title}
                    Description={UrlBlog.Description}
                    LinkImage={UrlBlog.LinkImage}
                />

                {/* BODY */}
                <main className="main-blog">
                    < MainBlog url={UrlBlog} />
                    < Disqus />
                </main>

                {/* Script for which disqus functions */}
                <script id="dsq-count-scr" src="//eliud-cesar-info.disqus.com/count.js" async></script>
                </>
                : < ErrorBlog />
        )
    }
}

export default PageInputBlog;